module.exports = __webpack_public_path__ + "img/menu.095a2995.svg";